// planetButtons.js
var PlanetButtons = pc.createScript('planetButtons');

PlanetButtons.attributes.add('buttonProt', {type:'entity', array:true});
PlanetButtons.attributes.add('screen', {type:'entity'});

// initialize code called once per entity
PlanetButtons.prototype.initialize = function() {
    this.app.on('solarSystem:allPlanets', this.setButtons, this);
    this.app.on('solarSystem:urlPlanet', this.setMarkerUrl, this);
    this.app.on('systemGenerator:reset', this.reset, this);
    this.app.on('userInput:test', this.setMarker, this);
    this.margin = 75;
    this.btnContainer = this.entity.parent.findByName('buttonContainer');
    this.clones = [];
    this.planetList = [];
    this.buttonsSet = false;
    this.sun = null;
    
};

PlanetButtons.prototype.reset = function() {
    this.buttonsSet = false;
    for(var kll = 0; kll < this.clones.length; kll++){
       this.clones[kll].destroy();
    }
    this.clones = [];
};


PlanetButtons.prototype.setMarker = function(ent){

    if(this.buttonsSet){
        for(var hd = 0; hd < this.clones.length; hd++){
            this.clones[hd].children[1].enabled = false;
        }
        if(ent.name == 'system'){
            this.clones[0].children[1].enabled = true;
            return;
        }
        // console.log('setMarker: ' + ent.name);
        for(var plt = 0; plt < this.planetList.length+1; plt++){
            if(this.planetList[plt-1] == ent){
                this.clones[plt].children[1].enabled = true;
            }
        }
    }
};

PlanetButtons.prototype.setMarkerUrl = function(ent){
// console.log('SETMARKERULR');
    if(this.buttonsSet){
        for(var hd = 0; hd < this.clones.length; hd++){
            this.clones[hd].children[1].enabled = false;
        }
        if(ent.name == 'system'){
            this.clones[0].children[1].enabled = true;
            return;
        }
        // console.log('setMarker: ' + ent.name);
        for(var plt = 0; plt < this.planetList.length+1; plt++){
            if(this.planetList[plt-1] == ent){
                this.clones[plt].children[1].enabled = true;
            }
        }
    }
};


PlanetButtons.prototype.setButtons = function(plnts, sn){
      
    this.planetList = plnts;
    this.sun = sn;
   
    var sunCln = this.buttonProt[0].clone();
    sunCln.enabled = true;
    sunCln.setLocalPosition(0,0,0);
    this.btnContainer.addChild(sunCln);
    sunCln.script.quickLink.planetType = 'system';
    sunCln.script.quickLink.thePlanet = sn; 
    this.clones.push(sunCln);
    var sunPos = sunCln.getLocalPosition();
    var scl = new pc.Vec3(0,0,0);
    
    for(var loop = 0; loop < plnts.length; loop++){

        var cln = null;
        if(plnts[loop].name == 'gasGiant'){
            cln = this.buttonProt[1].clone();
        } else if(plnts[loop].name == 'habitable'){
            cln = this.buttonProt[2].clone();
        } else if(plnts[loop].name == 'rockPlanet'){
            cln = this.buttonProt[3].clone();
        }
        this.btnContainer.addChild(cln);
        cln.enabled = true;

        cln.element.useInput = true;
        cln.script.quickLink.thePlanet = plnts[loop];
        cln.script.quickLink.thePosition = plnts[loop].getPosition();
        cln.script.quickLink.planetType = plnts[loop].name;
        cln.script.quickLink.order = loop;
        cln.script.quickLink.scaleIn(loop);
        
        this.clones.push(cln);
    }
    this.buttonsSet = true;
}; 


// swap method called for script hot-reloading
// inherit your script state here
// PlanetButtons.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

